import { Logo } from './logo';
import { NotificationCenter } from './NotificationCenter';
import { TeamSwitcher } from './TeamSwitcher';
import { USER_ROLES } from '@/config/permissions';
import { useTeamContext } from '@/hooks/useTeamContext';
import { cn } from '@/lib/utils';

interface SidebarChromeProps {
  onLogoClick?: () => void;
  showTeamSwitcher: boolean;
  logoVariant?: 'white' | 'default';
  className?: string;
  showLogo?: boolean;
  showNotifications?: boolean;
}

export function SidebarChrome({
  onLogoClick,
  showTeamSwitcher,
  logoVariant = 'white',
  className,
  showLogo = true,
  showNotifications = true,
}: SidebarChromeProps) {
  return (
    <div className={cn('flex flex-col gap-0 w-full', className)}>
      {(showLogo || showNotifications) && (
        <div className="flex items-center justify-between px-3 pt-2">
          {showLogo && onLogoClick ? (
            <Logo
              width={105}
              height={36}
              className="mb-3 cursor-pointer"
              variant={logoVariant}
              onClick={onLogoClick}
            />
          ) : (
            <div />
          )}
          {showNotifications && (
            <div className="mb-3">
              <NotificationCenter />
            </div>
          )}
        </div>
      )}
      {showTeamSwitcher && (
        <div className="w-full px-1">
          <TeamSwitcher />
        </div>
      )}
    </div>
  );
}

export function useSidebarChromeState() {
  const { effectiveRole, globalRole, teams } = useTeamContext();
  const role = effectiveRole || globalRole;
  const isFreelancer = globalRole === USER_ROLES.FREELANCER;
  const showTeamSwitcher = teams.length > 1 || isFreelancer;

  const getLogoTarget = () => {
    if (role === USER_ROLES.SUPER_ADMIN) return '/super-admin';
    if (role === USER_ROLES.FREELANCER) return '/missions';
    return '/freelancers';
  };

  return { showTeamSwitcher, getLogoTarget, role, isFreelancer };
}
